module.exports = {"310107005":"曹杨新村街道","310107014":"长风新村街道","310107015":"长寿路街道","310107016":"甘泉路街道","310107017":"石泉路街道","310107020":"宜川路街道","310107021":"万里街道","310107022":"真如镇街道","310107102":"长征镇","310107103":"桃浦镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310107.json
// module id = 749
// module chunks = 0